import { MOBILE_WIDTH } from '@/constants';

import { useWindowWidth } from './useWindowWidth';

export function useBreakpoint() {
  const { width } = useWindowWidth();
  const isMobile = width < MOBILE_WIDTH;

  return {
    isMobile,
  };
}
